// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr: false,
    onSignal: {
        id: '9f40e972-a8ab-4569-85a0-51346c00a235',
        apiKey: 'ZTI1OTYyMTAtYmE0MS00ODdmLWFjNWQtZDYzN2M1OTExNTU2',
    },
    notificatiosn : {
        client: {
            CONTRATTO_ATTIVO: "Il tuo contratto è attivo",
            CONTRATTO_30GIORNI_PRE_SCADENZA: "Il tuo contratto scade fra 30 giorni",
            Rinnovo_Contratto: "Il tuo contratto è stato prorogato",
            Contratto_scaduto: "Il tuo contratto è terminato",
            Risposta_del_supporto: "Hai ricevuto un riisposta al ticket dal supporto"
        },
        commerciale: {
            CONTRATTO_ATTIVO: "Il contratto di [NOME] [COGNOME]  è Attivo",
            CONTRATTO_30GIORNI_PRE_SCADENZA: "Il contratto di [NOME] [COGNOME] scade fra 30 giorni",
            Rinnovo_Contratto: "Il tuo contratto è stato prorogato",
            Contratto_scaduto: "Il contratto di [NOME] [COGNOME] è terminato",
            Nuovo_ticket_supporto: "Hai ricevuto un nuovo ticket da [NOME] [COGNOME]",
            Contratto_Verificato: "Il contratto di [NOME] [COGNOME] è stato verificato e firmato"


        },
        amministratore: {
            nuovo_cliente: "un nuovo cliente è stato inserito",
            nuovo_commerciale: "un nuovo commerciale è stato inserito",
            Rinnovo_Contratto: "Il contratto di [NOME] [COGNOME] è stato inserito per la proroga",
            Contratti_in_Scadenza: "Il contratto di [NOME] [COGNOME] è terminato",
            Contratto_da_verificare: "Un nuovo contratto è stato inserito: [NOME] [COGNOME]",
            Contratto_Bonificato: "Il contratto è stato Bonificato",
            Ticket_Supporto: "Hai ricevuto un nuovo ticket da NOME CLIENTE",
            Documento_Caricato: "Il documento  [NOMEDOCUMENTO] è stato caricato",

        }
    },

};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
